import React from 'react';

function NoTodayVisit() {
	return (
		<div className="practiceManagementForm" style={{ border: '1px solid #dadada' }}>
			<div className="noDataFound">
				<p>No Today Visit Found</p>
			</div>
		</div>
	);
}
export default NoTodayVisit;
